/* eslint-disable camelcase */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';
import { useRouter } from 'next/router';
import Link from 'next/link';
import s from './StateFuelTable.module.scss';

type DataTypes = {
  data: any[];
};

export const StateFuelTable = ({ data }: DataTypes) => {
  const router = useRouter();
  function formateSlug(stateName) {
    stateName = stateName?.replace(' & ', '-')?.replace(' ', '-');

    return stateName.toLowerCase();
  }

  return (
    data?.length > 0 && (
      <>
        <section className={s.root}>
          <table
            data-name={`Petrol & Diesel Price in ${data[0]['petrol'].state_name}`}
            className={s.table}
            itemScope
            itemType="http://schema.org/Table"
          >
            <thead>
              <tr>
                <th itemProp="name">
                  <p>
                    <span>City</span>
                  </p>
                </th>
                <th itemProp="name">
                  <p>
                    <span>Petrol</span>
                  </p>
                </th>
                <th itemProp="name">
                  <p>
                    <span>Diesel</span>
                  </p>
                </th>
              </tr>
            </thead>
            <tbody>
              {data?.map((item) => (
                <tr key={item?.petrol?.city_code}>
                  <td
                    style={{ cursor: 'pointer' }}
                    onClick={() =>
                      router.push(
                        `/fuel-price/petrol-diesel-price-in-${formateSlug(
                          item?.petrol?.city_code
                        )}`
                      )
                    }
                    itemProp="description"
                  >
                    <Link
                      href={`/fuel-price/petrol-diesel-price-in-${formateSlug(
                        item?.petrol?.city_code
                      )}`}
                    >
                      {item?.petrol?.city_name}
                    </Link>
                  </td>

                  <td>
                    <div className={s.price}>
                      <span itemProp="description">
                        {item?.petrol?.fuel_price}
                      </span>
                      <span
                        className={
                          item?.petrol?.price_change > 0
                            ? s.negative_change
                            : s.positive_change
                        }
                      >
                        {item?.petrol?.price_change}
                      </span>
                    </div>
                  </td>
                  <td>
                    <div className={s.price}>
                      <span itemProp="description">
                        {item?.diesel?.fuel_price}
                      </span>
                      <span
                        className={
                          item?.diesel?.price_change > 0
                            ? s.negative_change
                            : s.positive_change
                        }
                      >
                        {item?.diesel?.price_change}
                      </span>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>
      </>
    )
  );
};
